import { useState } from "react";
import { getApplicationDocumentNotice } from "service/api";

export const useConstructAndDownloadNotificationDocument = () => {
  const [isPending, setPending] = useState(false);

  const download = async (applicationId: string) => {
    try {
      setPending(true);
      const res = await getApplicationDocumentNotice({
        applicationId: applicationId,
      });
      if (!res) throw new Error("No response");
      const { url: href, filename } = res;
      const link = document.createElement("a");
      link.href = href;
      link.setAttribute("download", filename); //or any other extension
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error: any) {
      console.error(error);
      alert(error.message)
    } finally {
      setPending(false);
    }
  };
  return { isPending, download };
};
